const ErrorList = ({ list }) => {
  return list.length > 0 ? (
    <div className="relative overflow-x-auto">
      <table className="error-table w-full">
        <thead className="error-header">
          <tr>
            <th scope="col" className="error-cell-header">
              ID
            </th>
            <th scope="col" className="error-cell-header">
              Error
            </th>
          </tr>
        </thead>
        <tbody>
          {list.map((_error, index) => (
            <tr
              className="error-row bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200"
              key={`error-list-${index}`}
            >
              <th scope="row" className="error-id-column error-cell">
                {index + 1}
              </th>
              <td className="error-content error-cell">{_error}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : null;
};

export { ErrorList };
